export const validationRules: { [key: string]: (value: any) => string | null } = {

    only_number: (value) => {
        const regex = /^[0-9 ]+$/;
        if (!value) return 'This field is required';
        if (!regex.test(value)) return 'Only numbers and spaces are allowed';
        return null;
    },

    only_letters: (value) => {
        const regex = /^[A-Za-z\s]+$/;
        if (!value) return 'This field is required';
        if (!regex.test(value)) return 'Only letters and spaces are allowed';
        return null;
    },

    combination_of_numbers_alpha: (value) => {
        const regex = /^[A-Za-z0-9 ]+$/;
        if (!value) return 'This field is required';
        if (!regex.test(value)) return 'Only letters, numbers, and spaces are allowed';
        return null;
    },

    decimal_number: (value) => {
        const regex = /^[0-9]+(\.[0-9]+)?$/;
        if (!value) return null;
        if (!regex.test(value)) return 'Only decimal numbers are allowed';
        return null;
    },

    only_string: (value) => {
        if (value === '' || value === null || value === undefined) {
            return 'This field is required';
        }
        const valueStr = String(value).trim();
        const isOnlyNumbers = /^[0-9]+(\.[0-9]+)?$/.test(valueStr);

        if (isOnlyNumbers) {
            return 'Only letters are allowed';
        }
        return null;
    },

    is_empty: (value) => {
        if (value === null || value === undefined) {
            return 'This field is required';
        }
        if (typeof value === 'string' && value.trim() === '') {
            return 'This field is required';
        }
        if (typeof value === 'number' && isNaN(value)) {
            return 'This field is required';
        }
        if (Array.isArray(value) && value.length === 0) {
            return 'This field is required';
        }
        return null;
    },

};